import React from 'react';
import './PressPage.css';
import Seo from "./components/Seo";

const PressArchive2024 = () => {
    return (
        <div className="press-page">
            <Seo
                title="2024 Press Release — NYX NoCode"
                description="Press release from the 2024 NYX NoCode Hackathon at Mena School District."
            />
            <header className="press-header">
                <h1>Press Archive - 2024</h1>
            </header>

            <article className="press-release">
                <div className="press-release-header">
                    <div className="press-download-corner">
                        <a href="/NYX_NoCode_Press_Release_2024.pdf" download="NYX_NoCode_Press_Release_2024.pdf" className="download-button">
                            📄 Download PDF
                        </a>
                    </div>
                    <h3>FOR IMMEDIATE RELEASE</h3>
                    <h2 className="press-title-normal">Mena School District and Local Tech Startup partner together for an innovative NoCode Hackathon</h2>
                    <p className="press-dateline"><strong>Mena, AR</strong> – Fall 2024</p>
                </div>

                <div className="press-content">
                    <p>
                        The Mena School District is excited to share the progress of the <strong>Mena School District
                        NoCode Hackathon</strong>, a month-long event where local students are using cutting-edge
                        technology from a local Arkansas tech startup to support their community.
                    </p>

                    <p>
                        The hackathon, which began on November 1 and runs through November 29, challenges middle and
                        high school students to use the NYX NoCode platform to build innovative digital solutions that
                        will promote the new <strong>Trails at Mena Project</strong>, a major mountain biking initiative
                        currently underway in the Ward Lake Zone.
                    </p>

                    <p>
                        The Trails at Mena Project aims to establish Mena, Arkansas, as a premier destination for
                        outdoor recreation, with an expansive network of singletrack trails being built to attract
                        mountain bikers and outdoor enthusiasts from all over. Students participating in the hackathon
                        will be tasked with creating projects that promote and support this ambitious trail system,
                        whether by developing apps that highlight the trails, tools that encourage local cycling
                        tourism, or solutions that integrate cycling into Mena's broader community life.
                    </p>

                    <p>
                        The NYX NoCode platform, developed by founder Karen Kilroy, enables users to build websites and
                        applications without writing a single line of code. Students will use this platform for their
                        hackathon projects. In this open-ended challenge, students will experiment with NYX NoCode's
                        capabilities and explore creative ways to support the trail system and cycling culture in Mena.
                        The hackathon will also test the limits for the no-code platform to see what it is capable of
                        producing.
                    </p>

                    <blockquote>
                        "The opportunity to support the GenAI NoCode Hackathon in the Mena School District resonated
                        deeply with me," said <strong>Ulises Bejarano</strong>, Director of Software Engineering at
                        Walmart Global Tech. "Having spent 25 years in software engineering, I recognize the
                        transformative potential of artificial intelligence. Empowering the next generation with these
                        cutting-edge tools is not just an investment in their future—it's essential for fostering
                        innovation in our region. I'm particularly grateful to Walmart for their generous support in
                        providing students an incentive, helping make this initiative even more impactful."
                    </blockquote>

                    <p>
                        <strong>Karen Kilroy</strong>, visionary technologist and CEO of NYX NoCode LLC, is the driving
                        force behind the Mena NoCode Hackathon. Her creation, NYX NoCode, was launched in June 2024 as a
                        revolutionary platform that democratizes access to AI-powered development tools. Under Karen's
                        leadership, NYX NoCode empowers anyone to build credentialed websites and applications through a
                        simple prompt-driven interface. Her leadership in AI and blockchain technologies, including her
                        work as the AI/ML Task Force Co-Chair for the Coalition for Content Provenance and Authenticity
                        (C2PA), has made Karen a key player in shaping the future of digital innovation.
                    </p>

                    <blockquote>
                        "The Mena NoCode Hackathon is a remarkable opportunity for students to dive into real-world
                        problem-solving while utilizing an innovative platform from a local tech founder and her
                        startup. These students aren't just developing websites or apps—they're building skills that can
                        help fuel Arkansas's tech ecosystem and strengthen Mena's appeal as a destination for outdoor
                        enthusiasts," said <strong>Kristopher Adams</strong>, Program Manager of ARise. "Empowering
                        young Arkansans to create, solve, and innovate is exactly what the ARise program is all about."
                    </blockquote>

                    <p>
                        Participants are working in teams to develop digital products, with each team member taking on
                        roles such as project manager, designer, developer, content creator, or QA tester. <strong>Dr.
                        Lee Smith</strong>, Superintendent of Mena School District, expressed his enthusiasm for the
                        event, saying, "The first line in our district vision slogan is 'our students are prepared,' and
                        what better way to prepare them than modifying real life and real work with real problems in a
                        way that they can handle and feel accomplished. This public school with business world
                        partnership is the best way to make this happen, and we need to replicate it as much as we can."
                        Students are being guided by their teachers, Krystal Titsworth and Sarah Billings, with support
                        from mentors at Walmart, ARise, Startup Junkie, and NYX NoCode. Projects will be evaluated by a
                        panel of judges, who will review the students' work based on criteria such as creativity,
                        functionality, and relevance to the Trails at Mena Project.
                    </p>

                    <blockquote>
                        "The best way to learn is by doing, and a nocode hackathon empowers everyone to create what they
                        envision. NYX NoCode steps students through a critical job skill–prompt engineering–in an
                        exploratory, interactive format. It works like this: a student writes a prompt–which is a
                        description of what they want to create. The prompt goes to NYX NoCode and within 40 seconds
                        they see their creation on the screen, which can be quite elaborate, and include AI generated
                        images, text, graphic design, websites, and even interactive applications. NYX NoCode has a
                        brand new doodle pad interface designed for less verbal prompt building, which guesses what a
                        student is drawing, as they draw. We will soon be adding a MIDI interface so students can play
                        musical instruments to create drawings. The students' feedback is critical to NYX NoCode's
                        roadmap."
                    </blockquote>

                    <p>
                        To recognize their efforts, Walmart is rewarding each of the 200 participating students with a
                        $5 Walmart gift card, along with swag from LockStop, NYX NoCode, Startup Junkie, ARise, and
                        Beeline MTB. The <strong>Mena School District NoCode Hackathon 2024</strong> is sponsored by
                        Walmart, NYX NoCode, Startup Junkie Foundation, ARise, LockStop, AWS, and Beeline MTB, with
                        additional support for filming, prizes, and mentorship provided throughout the event.
                    </p>

                    <div className="press-contact">
                        <p><strong>For more information, contact</strong> Karen Kilroy at <a
                            href="mailto:info@nyx.baby">info@nyx.baby</a>.</p>
                    </div>

                    <div className="about-highlights">
                        <div className="about-nyx">
                            <h3>About NYX NoCode</h3>
                            <p>
                                NYX NoCode is an innovative platform that allows you to create entire web pages and other
                                digital content simply by using text prompts or doodles, without needing any coding skills.
                                Designed to be incredibly user-friendly, NYX NoCode harnesses the power of AI to interpret
                                your inputs and generate fully functional web creations. This makes it perfect for anyone
                                from kids to seasoned professionals looking to streamline their workflow. The platform also
                                includes features like a prompt library for reusing previous commands and seamless
                                integration with large companies' internal AI systems. Essentially, NYX NoCode brings
                                clarity out of chaos, making web development accessible and efficient for everyone.
                            </p>
                        </div>
                        <div className="about-karen">
                            <h3>About Karen Kilroy</h3>
                            <p>
                                <a
                                    href="https://karenkilroy.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="about-karen-link"
                                >
                                    Karen Kilroy
                                </a>{' '}
                                is a six-time IBM Champion, AI engineer, and author of four O'Reilly books on artificial intelligence and
                                technology, including <em>Blockchain as a Service</em> (2019), <em>AI and the Law</em> (2021),
                                <em>Blockchain Tethered AI</em> (2023), and <em>Natural Language and Search</em> (2024). She is the creator of
                                NYX NoCode, an innovative platform that makes AI and web development accessible through prompts and doodles.
                                Karen has been recognized for her ability to translate emerging technologies into practical, inclusive tools—
                                winning the IBM Watson Build Challenge in 2017, completing advanced AI fluency training with Anthropic,
                                and serving as Co-Chair of the C2PA AI/ML Task Force and a member of the SMPTE/ETC AI/ML Task Force.
                            </p>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    );
};

export default PressArchive2024;
